<div class="interval">
    <div class="date interval-from-date text-gray-600" [class.text-gray-600]="!fromDateDifferent" [class.text-warning-600]="fromDateDifferent">{{ fromDate }}</div>
    <div class="date interval-from-time">{{ fromTime }}</div>
    <div class="interval-dash">-</div>
    <div class="date interval-to-time" [class.text-error]="pending">{{ toTime }}</div>
    <div class="date interval-to-date" [class.text-gray-600]="!toDateDifferent" [class.text-warning-600]="toDateDifferent">{{ toDate }}</div>
</div>
